import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChangesNotSavedGuard } from '../shared/changes-not-saved';
import { SharedModule } from '../shared/shared.module';
import { ApplicationRoutingModule } from './application-routing.module';
import { ApplicationComponent } from './application.component';
import {
    BackgroundFormComponent,
    DisclosureFormComponent,
    PersonalInformationFormComponent,
    YourEducationFormComponent
} from './components';
import {
    ApplicationConfirmationComponent,
    ApplicationSubmittedComponent,
    BackgroundComponent,
    DialogContentComponent,
    DisclosureComponent,
    PersonalInformationComponent,
    YourEducationComponent
} from './pages';
import { AutocompletePipe } from './pipes';
import { FullNamePipe } from './pipes/full-name.pipe';

@NgModule({
    declarations: [
        ApplicationComponent,
        PersonalInformationComponent,
        YourEducationComponent,
        BackgroundComponent,
        DisclosureComponent,
        DialogContentComponent,
        ApplicationSubmittedComponent,
        ApplicationConfirmationComponent,
        BackgroundFormComponent,
        AutocompletePipe,
        PersonalInformationFormComponent,
        YourEducationFormComponent,
        DisclosureFormComponent,
        FullNamePipe
    ],
    providers: [ChangesNotSavedGuard],
    imports: [CommonModule, ApplicationRoutingModule, SharedModule]
})
export class ApplicationModule {}
